const breakpoints = {
    xl: 1200,
    lg: 992,
    md: 738,
    sm: 576,
    xs: 376,
    xxs: 0
};

export default breakpoints;